import { render, staticRenderFns } from "./RsaPazientePrescrizioneFarmaciComponent.vue?vue&type=template&id=0d66310a&scoped=true"
import script from "./RsaPazientePrescrizioneFarmaciComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePrescrizioneFarmaciComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazientePrescrizioneFarmaciComponent.vue?vue&type=style&index=0&id=0d66310a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d66310a",
  null
  
)

export default component.exports